export default __webpack_public_path__ + "static/media/main box3.49405cc8.png";